import {
  PricingMode,
  EditPricingModeDocument,
} from '@/lib/graphql/generated/graphql';
import { trackEvent } from '@/lib/mixpanel';
import { dealRefetchAtom } from '@/states/deal.state';
import { pricingModeState } from '@/states/pricing-mode.state';
import { useMutation } from '@apollo/client/react';
import { useAtomValue, useSetAtom } from 'jotai';

import { useDealNotEditableHandler } from './useDealNotEditableHandler';

export function useEditPricingMode(dealId: string) {
  const setPricingMode = useSetAtom(pricingModeState);
  const dealRefetch = useAtomValue(dealRefetchAtom);

  const [editPricingMode] = useMutation(EditPricingModeDocument);
  const { handleIfDealNotEditable } = useDealNotEditableHandler();

  const handlePricingModeChange = async (newMode: PricingMode) => {
    const result = await editPricingMode({
      variables: {
        dealId,
        pricingMode: newMode,
      },
    });

    const payload = result.data?.updateDealPricingMode;
    if (payload?.__typename === 'DomainException') {
      handleIfDealNotEditable(payload.code);
      return result;
    }

    await dealRefetch.fn();
    setPricingMode(newMode);
    trackEvent('PRICING_MODE_CHANGED', { dealId, modeTo: newMode });
    return result;
  };

  return {
    handlePricingModeChange,
  };
}
